import React from 'react';
import { Mail, ArrowRight } from 'lucide-react';

const StepEmail = ({ email, setEmail, emailError, onNext, loading }) => {
    return (
    <div className="fp-step">
      <div className="fp-step__icon"><Mail size={26} /></div>
      <h3 className="fp-step__title">Reset your password</h3>
      <p className="fp-step__sub">Enter your registered email or phone number and we'll send you a verification code.</p>

      <div className="fp-field">
        <label>Email or Phone</label>
        <input
          type="text"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="fp-input"
        />

         {emailError && (
    <p className="fp-error">{emailError}</p>
  )}
      </div>

      <button
        className="fp-btn-primary"
        onClick={onNext}
        disabled={loading}
      >
        {loading ? <span className="fp-spinner" /> : <>Send Code <ArrowRight size={16} /></>}
      </button>
    </div>
  );
};

export default StepEmail;